export default "__VITE_ASSET__BI53Li7Q__"